module.exports = __webpack_public_path__ + "static/media/mastercard.94c98607.svg";